module.exports = __webpack_public_path__ + "static/media/AG.8bd07b26.svg";